import React, { useEffect } from "react";

import Popup from "../../../components/common/model/Popup";
import {
  Alert,
  Button,
  DialogContent,
  DialogContentText,
  Typography,
} from "@mui/material";
import closeIcon from "../../../assets/closeModel.png";
import CustomButton from "../../../components/common/button/CustomButton";
import useStyles from "../../../components/common/model/styles";
import { useDispatch } from "react-redux";
import { DBOConnectQuickBookAction, setErrorUploadToQuickBookAction, uploadToQuickBookAction } from "../../../store/reducers/invoiceSlice";
import Notification from "../../../components/common/notification/Notification";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { setNotificationAction } from "../../../store/reducers/mmymSlice";

interface ActivationPopupProps {
  title?: string | undefined | null;
  open: boolean;
  onHide?: () => void;
  setOpen?: (open: boolean) => void;
  selectedInvoice?: string | number | null;
}
const AlertForQuickBook: React.FC<ActivationPopupProps> = ({
  onHide,
  open,
  title,
  selectedInvoice,
  setOpen,
}) => {
  const classes = useStyles();
  const { isUploadQuickBookError,dboLinkResponse } = useSelector((state: any) => state.invoice);
    const { user } = useSelector(
    (state: any) => state?.user
  );
  const dispatch = useDispatch();
  const submitHandler = () => {
    if (selectedInvoice) {
      dispatch(uploadToQuickBookAction({ invoice_number: selectedInvoice }));
    }
  };
  const closeModel = () => {
    if (setOpen) {
      setOpen(false);
      dispatch(setErrorUploadToQuickBookAction(false));
      dispatch(setNotificationAction({ message: [], severity: "error" }));
    }
  };

  useEffect(()=>{
    if(isUploadQuickBookError){
      dispatch(DBOConnectQuickBookAction({ tenant_id: user?.user?.tenantId ?? user?.user?.tenant_id }) );
    }
  },[isUploadQuickBookError])

 useEffect(()=>{
  if(dboLinkResponse && isUploadQuickBookError){
    window.open(dboLinkResponse?.url, '_blank');
  }
 },[dboLinkResponse])

  return (
    <Popup
      open={open}
      title={"Upload to QuickBooks"}
      onHide={closeModel}
      fullWidth={true}
      maxWidth={"xs"}
      aria-describedby="alert-dialog-slide-description"
      header={
        <>
          <img
            onClick={closeModel}
            src={closeIcon}
            className={classes.closeicons}
            alt="close"
          />
        </>
      }
      footer={
        <>
          <CustomButton variant="outlined" title="No" onClick={closeModel} />
          <CustomButton title="Yes" onClick={submitHandler} />
        </>
      }
    >
      <DialogContent sx={{ padding: "0px" }}>
        <Notification />
        {isUploadQuickBookError && (
          <Link
            style={{
              textDecoration: "none",
              textAlign: "center",
              display: "block",
              marginBottom: "10px",
            }}
            target="_blank"
            to={dboLinkResponse?.url || '#'}
          >
            Please click here to go to QuickBooks Account Page
          </Link>
        )}

        <DialogContentText>
          <Alert
            sx={{ bgcolor: "#eeecef", fontSize: "16px" }}
            severity="warning"
          >
            Are you sure, you want to upload quickbooks for this invoice ?
          </Alert>
        </DialogContentText>
      </DialogContent>
    </Popup>
  );
};

export default AlertForQuickBook;
